import * as d3 from "d3";
{
  class RadialProgressController {
    constructor($attrs, $timeout) {
      'ngInject';

      this.$timeout = $timeout;
      this.id = $attrs.id;
      this.start = this.start || 0;
      this.end = this.end || 0;
    }

    $onChanges() {
      if (this.initialized) {
        this.reset();
        this.loop();
      }
    }

    $onInit() {
      this.$timeout(() => {
        this.init();
        $(window).on('resize', this.resize.bind(this));
      });
    }

    getBox() {
      let {
        clientWidth: x,
        clientHeight: y
      } = this.container._groups[0][0],
          radius = x / 2,
          padding = 8;
      return {
        x,
        y,
        radius: radius - padding - this.strokeWidth,
        boxSize: radius * 2
      };
    }

    init() {
      this.container = d3.select(`#${this.id} .radial-progress`);
      this.svg = this.container.append('svg');
      this.group = this.svg.append('g');
      this.arc = d3.arc();
      this.meter = this.group.append('g').attr('class', 'progress-meter');
      this.background = this.meter.append('path').attr('class', 'background').attr('fill', '#ccc').attr('fill-opacity', 1).attr('stroke-width', this.strokeWidth);
      this.foreground = this.meter.append('path').attr('class', 'foreground').attr('fill', this.color).attr('fill-opacity', 1).attr('stroke', this.color).attr('stroke-opacity', 1);
      this.numberText = this.meter.append('text').attr('fill', '#000').attr('font-size', '54').attr('font-family', 'OpenSans').attr('font-weight', '300').attr('text-anchor', 'middle').attr('dy', '0.35em');
      this.initialized = true;

      this.reset();
      this.resize();
      this.loop();
    }

    resize() {
      const box = this.getBox();
      this.svg.attr('width', box.boxSize).attr('height', box.boxSize);
      this.arc.startAngle(0).innerRadius(box.radius).outerRadius(box.radius + this.strokeWidth);
      this.group.attr('transform', `translate(${box.boxSize / 2},${box.boxSize / 2})`);
      this.numberText.attr('font-size', box.boxSize / 3);
      this.draw();
    }

    loop() {
      this.draw();

      if (this.decrementer > 0) {
        this.decrementer--;
        this.progress += this.step;
        this.$timeout(this.loop.bind(this), 10);
      }
    }

    draw() {
      if (!this.initialized) {
        return;
      }

      const twoPi = Math.PI * 2;
      this.background.attr('d', this.arc.endAngle(twoPi));
      this.foreground.attr('d', this.arc.endAngle(twoPi * this.progress));
      this.numberText.text(this.count);
    }

    reset() {
      this.decrementer = Math.abs((this.end - (this.progress || this.start)) / 0.01);
      this.step = this.end < this.progress ? -0.01 : 0.01;
      this.progress = this.progress || this.start;
    }

  }

  RadialProgressController.$inject = ["$attrs", "$timeout"];
  angular.module('pims').component('radialProgress', {
    template: '<div class=\'radial-progress\'></div>',
    controller: RadialProgressController,
    bindings: {
      strokeWidth: '<',
      color: '<',
      count: '<',
      end: '<',
      start: '<'
    }
  });
}
